<template>
  <van-dialog
    v-model="value"
    :title="title"
    :show-cancel-button="false"
    :show-confirm-button="false"
    class="custom-dialog"
  >
    <slot class="dialog-content"></slot>
    <button
      class="van-button van-button--default van-button--largeitserve-app-color mt-25 modal-custom-ok"
      @click="hideDialog"
      style="font-size: 18px; font-weight: bold"
    >
      {{ $t("buttons.modalOkBtn") }}
    </button>
  </van-dialog>
</template>

<script>
import "vue-awesome/icons/check";
import Dialog from "vant/lib/dialog/index";
export default {
  name: "SimpleDialog",
  props: {
    title: String,
    value: Boolean,
    success: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      closeTimeout: null,
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  watch: {
    value: function (val) {
      if (val === true) {
        this.closeTimeout = setTimeout(() => {
          // this.hideDialog();
        }, 5000);
      } else {
        clearTimeout(this.closeTimeout);
      }
    },
  },
  methods: {
    hideDialog() {
      this.$emit("input", false);
      this.$emit("change");
    },
  },
};
</script>

<style>
/* Глобальные стили для диалога в темной теме */
.app-theme-dark .van-dialog {
  background-color: #0e121c !important;
}

.app-theme-dark .van-dialog__header {
  color: #ffffff !important;
}

.app-theme-dark .van-dialog__message {
  color: #ecf0f1 !important;
}

/* Стиль для кастомной кнопки внутри диалога */
.app-theme-dark .van-dialog .van-button {
  background-color: transparent !important;
}

/* Стиль для иконки-галочки */
.app-theme-dark .dialog-confirm-icon {
  color: #ffffff !important;
  fill: #ffffff !important; /* Добавлено для SVG */
}

/* Стиль для текста 'OK' */
.app-theme-dark .modal-custom-ok {
  color: #ffffff !important;
}
</style>
